import React, { CSSProperties } from 'react';

interface FloppyDiskProps {
  fill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const FloppyDisk: React.FC<FloppyDiskProps> = ({
  fill = 'currentColor',
  width = '100%',
  height = '100%',
  style,
  className,
}) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 1060 1060"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <g fill={fill}>
      <path
        d="M817.89 869H296.04c-28.24 0-51.13-22.89-51.13-51.13V296.13c0-28.24 22.89-51.13 51.13-51.13h396.2c13.63 0 26.7 5.44 36.3 15.12l126.44 127.45a51.098 51.098 0 0 1 14.83 36.11l-.79 394.3c-.06 28.2-22.93 51.03-51.13 51.03z"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="50px"
      />
      <path
        d="M402.16 245h234.62v156H402.16z"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="50px"
      />
      <path
        d="M368.82 682H745v187H368.82z"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="50px"
      />
    </g>
  </svg>
);

export default FloppyDisk;
